<script lang="ts">
  import { onMount } from 'svelte';
  import { installLinkInterceptor, path } from './lib/router';
  import Home from './routes/Home.svelte';
  import Edit from './routes/Edit.svelte';
  import Detail from './routes/Detail.svelte';

  onMount(() => {
    installLinkInterceptor();
  });

  const detailMatch = $derived($path.match(/^\/c\/([^/]+)$/));
  const editMatch = $derived($path.match(/^\/c\/([^/]+)\/edit$/));
</script>

{#if $path === '/' || $path === ''}
  <Home />
{:else if $path === '/new'}
  <Edit />
{:else if editMatch}
  <Edit id={editMatch[1]} />
{:else if detailMatch}
  <Detail id={detailMatch[1]} />
{:else}
  <Home />
{/if}
